export const frontmatter = {
    "draft": true,
    "title": "Access Tokens",
    "description": "Access token management in OnnIA.",
    "sidebar_label": "Access Tokens",
    "sidebar_group": "reference",
    "sidebar_order": 5
}

export const toc = []